import React, {useState, useEffect} from 'react';
import Axios from 'axios';

import { AppConstants } from '../AppConstants';
import AlertComponent from '../components/AlertComponent';
import LoadingComponent from '../components/LoadingComponent';

import { logoutUser } from '../helper/global-helper';

function Settings() {
    const dbBaseUrl = AppConstants().db_base_url;

    // loading and message display
    const [displayMsg, setDisplayMsg] = useState(null);
    const [showLoading, setShowLoading] = useState(false);
    const [loadingMsg, setLoadingMsg] = useState('');

    const [formSubmit, setFormSubmit] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPw, setConfirmPw] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const [userName, setUserName] = useState('');
    const [userEmail, setUserEmail] = useState('');

    function handleChangePassword(){
        setFormSubmit(true);
        setShowLoading(true);
        setLoadingMsg('Updating password. Please wait.');

        if( password === '' || password === null ){
            setShowLoading(false);
            return setDisplayMsg({type: 'error', message: 'Please enter your new password'})
        }
        if( confirmPw === '' || confirmPw === null ){
            setShowLoading(false);
            return setDisplayMsg({type: 'error', message: 'Please confirm your new password'})
        }
        if( confirmPw !== password ){
            setShowLoading(false);
            return setDisplayMsg({type: 'error', message: 'Passwords do not match'})
        }

        Axios.defaults.headers.common['x-access-token'] = localStorage.getItem("token")
        Axios.post(dbBaseUrl + "citizens-change-password", {
            userId: localStorage.getItem('id'),
            newPw: password
        })
        .then((response) => {
            setFormSubmit(false);
            setDisplayMsg(response.data);
            setShowLoading(false);

            if( response.data.code === 2 ){
                logoutUser(response.data.message);
            }
        })
        .catch(error => console.log(error));
    }

    function getUserInfo(){
        Axios.defaults.headers.common['x-access-token'] = localStorage.getItem("token")
        Axios.post(dbBaseUrl + "citizens-get-user-info", {
            userId: localStorage.getItem('id')
        })
        .then((response) => {
            if( response.data.type === 'success' ){
                setUserName(response.data.resultData[0].fullname);
                setUserEmail(response.data.resultData[0].email);
            } else {
                if( response.data.code === 2 ){
                    logoutUser(response.data.message);
                }
            }
        })
        .catch(error => console.log(error));
    }

    useEffect(() => {
        getUserInfo();
    //eslint-disable-next-line
    }, [])

    return (
        <div className='main-container container'>
            <h1 className='secondary bold'>Settings</h1>
            <hr/>

            {
                displayMsg !== null ? 
                    <AlertComponent message={displayMsg.message} color={`${displayMsg.type === 'error' ?  'danger' : displayMsg.type === 'success' ? 'success' : ''}`} textColor='primary'  />
                : null
            }

            <div className='container mt-4'>
                <h5 className='primary'><b>Name:</b> {userName}</h5>
                <h5 className='primary mb-4'><b>Email:</b> {userEmail}</h5>
                <hr/>
                <h2 className='primary bold'>Change Password</h2>

                <form className='mb-2' onKeyUp={(e) => e.key === 'Enter' && handleChangePassword()}>
                    <div className="input-group mb-3">
                        <span className="input-group-text"><i className={`fa-solid ${showPassword ? 'fa-eye' : 'fa-lock'}`}></i></span>
                        <input type={showPassword ? 'text' : 'password'} className={`form-control ${formSubmit && password === '' && 'is-invalid'}`} onChange={el => setPassword(el.target.value.trim())} placeholder="Enter your new password" aria-label="New Password" autoComplete="on" />
                    </div>
                    <div className="input-group">
                        <span className="input-group-text"><i className={`fa-solid ${showPassword ? 'fa-eye' : 'fa-lock'}`}></i></span>
                        <input type={showPassword ? 'text' : 'password'} className={`form-control ${formSubmit && confirmPw === '' && 'is-invalid'}`} onChange={el => setConfirmPw(el.target.value.trim())} placeholder="Confirm your password" aria-label="Confirm Password" autoComplete="on" />
                    </div>
                </form>

                <p className='primary pointer italic mt-2' onClick={(e) => setShowPassword(!showPassword)} >Show Password</p>
                <button className='btn-primary mt-2' onClick={() => handleChangePassword()}>Reset Password</button>
            </div>

            <LoadingComponent 
                show={showLoading}
                onHide={() => setShowLoading(false)}
                message = {loadingMsg}
                redirect = 'false'
            />
        </div>
    )
}

export default Settings